module.exports = __webpack_public_path__ + "media/banner.031f4e44.mp4";